import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { CloseAllModalsAction } from '../store/actions/app.custom-actions';

/**
 * Provides methods to close all open modals.
 * Use this service when you need to close modals before performing other actions.
 */
@Injectable({
  providedIn: 'root',
})
export class ModalService {
  constructor(private readonly store: Store) {}

  /**
   * This will close all Material Dialog modals that are currently open.
   * Use this before performing navigation or other actions that require
   * a clean UI state.
   */
  closeAllModals(): void {
    this.store.dispatch(new CloseAllModalsAction());
  }
}
